<div class="c-toast">
  <div class="c-toast__content">
    <h5 class="c-toast__title">
      {{ 'toastTitle' | translate }}
    </h5>
    <p class="c-toast__message">{{ data.translateKey | translate }}</p>

    <ul *ngIf="data.errors.length !== 0" class="c-toast__errors">
      <li *ngFor="let error of data.errors">
        {{ error | translate }}
      </li>
    </ul>
    <p *ngIf="showTimestamp" class="c-toast__timestamp">
      {{ errorTimestamp$ | async }}
    </p>
  </div>
  <div class="c-toast__close" (click)="close()"><i class="fas fa-times remove-icon" aria-hidden="true"></i></div>
</div>
